import { LinkFunction, LinkLocalProps } from '@/ui'
import { createContext, ReactNode } from 'react'
import { HtmlPortalNode } from 'react-reverse-portal'

export type MainNavConfig = {
	logoLinker: LinkFunction<LinkLocalProps>
	campaignsLinker: LinkFunction<LinkLocalProps>
	talentPoolLinker: LinkFunction<LinkLocalProps>
	analyticsLinker: LinkFunction<LinkLocalProps>
	whatsAppLinker: LinkFunction<LinkLocalProps>
	newCampaignLinker: LinkFunction<LinkLocalProps>
	profileLinker: LinkFunction<LinkLocalProps>
	preferencesLinker: LinkFunction<LinkLocalProps>
}

export type ProvidedMainNavConfigContextType =
	& {
		orgSwitcher: ReactNode
	}
	& MainNavConfig

export const ProvidedMainNavConfigContext = createContext<ProvidedMainNavConfigContextType>({
	logoLinker: () => null,
	campaignsLinker: () => null,
	talentPoolLinker: () => null,
	analyticsLinker: () => null,
	whatsAppLinker: () => null,
	newCampaignLinker: () => null,
	profileLinker: () => null,
	preferencesLinker: () => null,
	orgSwitcher: <></>,
})

export type MainNavPortalTargetContextType = {
	mainNavTargetNode: HtmlPortalNode | null
}

export const MainNavPortalTargetContext = createContext<MainNavPortalTargetContextType>({
	mainNavTargetNode: null,
})
